export const STREAM_EVENTS = {
    STREAM_STARTED: 'STREAM_STARTED',
    STAGE_STARTED: 'STAGE_STARTED',
    STAGE_COMPLETED: 'STAGE_COMPLETED',
    STAGE_FAILED: 'STAGE_FAILED',
    STREAM_COMPLETED: 'STREAM_COMPLETED',
};
